import axios from 'axios';
import { configRefs } from '@utils/constants';

async function deleteRevisionRequest(user, revision) {
  if (!user || !user.institution?.id) {
    throw new Error("deleteRevisionRequest(): missing user data");
  }
  if (!revision.__syncedWithBackend) {
    throw new Error("deleteRevisionRequest(): revision is not present in the backend");
  }
  await axios.delete(`${await configRefs.apis.userdata.get()}/api/CourseRevisions/${encodeURIComponent(revision.id)}`);
}

export { deleteRevisionRequest };
//# sourceMappingURL=request.delete.js.map
